import baseSlugify from 'slugify';

export function slugify(text: string) {
  return baseSlugify(text, {
    lower: true,
    strict: true,
  });
}
